import React from 'react'
import { Navigate } from 'react-router'

import { useAuth } from 'app/providers/auth/AuthProvider'
import { PathUtils } from 'routes/routes.utils'

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth()

  if (!user) {
    return <Navigate to={PathUtils.getAuth()} replace />
  }

  return <>{children}</>
}
